import { gql } from '@apollo/client';
import { LOCK_FRAGMENTS } from './fragments';

export const PARTY_LOCK = gql`
  ${LOCK_FRAGMENTS}
  mutation PartyLock($data: PartyLockInput!) {
    partyLock(data: $data) {
      lock {
        ...PartyLockFields
      }
    }
}`;

